<template>
  <div class="reserve">
      <div class="title">
          <span></span>
          <p class="tit">接种疫苗者身份信息：</p>
      </div>
      <div class="info"><p>姓名：</p><span>{{msg.name}}</span></div>
      <div class="info"><p>证件类型：</p><span>{{msg.identity_type_display}}</span></div>
      <div class="info"><p>证件号码：</p><span>{{msg.identity_code}}</span></div>
      <div class="info"><p>联系方式：</p><span>{{msg.phone}}</span></div>
      <div class="title">
          <span></span>
          <p class="tit">接种疫苗需求：</p>
      </div>
      <div class="tit2 tits"><p>1. 疫苗类型：<span>（*必选）</span></p></div>
      <label><input v-model="radioVal" type="radio" value="QUADRUPLE" checked @change="getRadioVal">四价疫苗</label>
      <label><input v-model="radioVal" type="radio" value="NINE_VALENT" @change="getRadioVal">九价疫苗</label>
      <div class="tit2"><p>2. 疫苗接种机构位置：<span>（*必选）</span></p></div>
      <div class="text"><input type="text" class="address" placeholder="请选择您希望在哪里接种疫苗" @click="address()" v-model="inputCity"></div>
      <div class="tit2"><p>3. 疫苗接种预约时间段：<span>（*必选）</span></p></div>
      <div class="text"><input type="text" class="address" placeholder="请选择您方便接种疫苗的时间段（以1周时间计算）" @click="calendar()" v-model="inputTime"></div>
      <div class="tit2"><p>4. 疫苗接种需求备注：</p></div>
      <div class="text"><textarea placeholder="如有特殊要求，请填写此处备注" v-model="inputTip" >
      </textarea></div>
      <div class="btn">
        <button @click="confirms()">确认并提交</button>
      </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      radioVal: "QUADRUPLE",
      msg: "",
      inputCity: "",
      inputTime: "",
      inputTip: ""
    };
  },
  created() {
    let _this = this;
    let cityname = sessionStorage.getItem("city");
    if (cityname != "") {
      this.inputCity = cityname;
    }
    let calendarDate = sessionStorage.getItem("calendar2");
    if (calendarDate != "") {
      this.inputTime = calendarDate;
    }
    axios.get(HPV_URL+"/api/member/").then(res => {
      this.msg = res.data.info;
      console.log(res.data.info);
    });
  },
  methods: {
    getRadioVal() {
      console.log(this.radioVal);
    },
    address() {
      this.$router.push({
        path: "/city"
      });
    },
    calendar() {
      this.$router.push({
        path: "/calendar",
        query:{
          channel:'HPV'
        }
      });
    },
    confirms() {
      let id = sessionStorage.getItem("member_id");
      if (this.radioVal == "" || this.radioVal == null) {
        this.$toast.text("请选择疫苗类型");
      } else if (this.inputCity == "" || this.inputCity == null) {
        this.$toast.text("请选择您希望在哪里接种疫苗");
      } else if (this.inputTime == "" || this.inputTime == null) {
        this.$toast.text("请选择您方便接种疫苗的时间段（以1周时间计算）");
      } else {
        var params = new FormData();
        params.append("memberRightId", id);
        params.append("vaccine_type", this.radioVal);
        params.append("vaccine_area", this.inputCity);
        params.append("booking_date", this.inputTime);
        params.append("remark", this.inputTip);
        axios
          .post(HPV_URL+"/api/bookings/", params)
          .then(res => {
            this.$router.push({
              path: "/success"
            });
          });
      }
    }
  }
};
</script>

<style scoped>
.title {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  display: flex;
}
.title span {
  width: 5px;
  height: 16px;
  display: block;
  background: #e24709;
  margin: 17px 10px 0 20px;
}
.info {
  margin-left: 20px;
  font-size: 14px;
  display: flex;
  line-height: 28px;
}
.info p {
  color: #4a4a4a;
  width: 80px;
}
.info span {
  color: #333;
}
.tit2 {
  font-size: 16px;
  margin: 20px;
}
.tits{
  margin-top: 0px;
}
.tit2 span {
  font-size: 12px;
  color: #e24709;
}
label {
  font-size: 14px;
  display: block;
  margin: 0 0 5px 20px;
}
input {
  width: 14px;
  height: 14px;
  line-height: 14px;
  margin: 1px 5px 0 0;
}
.text {
  margin: 0 20px;
}
.address {
  height: 34px;
  line-height: 34px;
  width: 100%;
  border-radius: 5px;
  border: 1px solid #979797;
  font-size: 12px;
  padding-left: 10px;
}
.tip {
  height: 114px;
  width: 100%;
  border-radius: 5px;
  border: 1px solid #979797;
  font-size: 12px;
  padding-left: 10px;
}
textarea {
  width: 100%;
  height: 75px;
  border-radius: 5px;
  border: 1px solid #979797;
  font-size: 12px;
  padding-left: 10px;
}
.btn {
  margin: 20px 20px;
}
.btn button {
  height: 48px;
  line-height: 48px;
  font-size: 18px;
  margin-top: 20px;
  text-align: center;
  background: #e24709;
  color: #fff;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/reserve.vue